import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Enterprise2SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="M4.941 2.31h6.715v10.5a1 1 0 0 1-1 1H4.941V2.31Zm-1.25 0H1.656v10.5a1 1 0 0 0 1 1h1.035V2.31Zm0 13H2.656a2.5 2.5 0 0 1-2.5-2.5v-12h13v12a2.5 2.5 0 0 1-2.5 2.5H4.941v1.126h-1.25V15.31ZM6.656 4.56h3v1.25h-3V4.56Zm.625 2.996h-.625v1.25h3v-1.25H7.281Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Enterprise2SVG;
